import styled from '@emotion/styled';
import Tabs from '../../../components/organisms/Tabs/Tabs';

export const Container = styled(Tabs)`
    display: flex;
    background-color: ${({ theme }) => theme.color.white100};
`;
